// src/scripts/PhotoUpload/components/FilePreview.js
import React from "react";
import { formatFileSize } from "../utils/formatters";

const FilePreview = ({ file, onUpload, onRemove }) => {
  const getStatusClass = (status) => {
    const baseClass = "px-2 py-1 rounded text-sm font-medium";
    switch (status) {
      case "processing":
        return `${baseClass} bg-blue-100 text-blue-800`;
      case "ready":
        return `${baseClass} bg-green-100 text-green-800`;
      case "uploading":
        return `${baseClass} bg-yellow-100 text-yellow-800`;
      case "uploaded":
        return `${baseClass} bg-green-100 text-green-800`;
      case "error":
        return `${baseClass} bg-red-100 text-red-800`;
      default:
        return `${baseClass} bg-gray-100 text-gray-800`;
    }
  };

  return (
    <div className="border rounded-lg p-4 mb-4 bg-white shadow-sm">
      {/* Preview Image */}
      {file.previewUrl && (
        <img
          src={file.previewUrl}
          alt={file.name}
          className="w-full h-32 object-cover rounded mb-3"
        />
      )}

      {/* File Info */}
      <div className="space-y-2">
        <h4 className="font-medium text-gray-900 truncate">{file.name}</h4>

        <div className="flex items-center justify-between">
          <span className={getStatusClass(file.status)}>
            {file.status.charAt(0).toUpperCase() + file.status.slice(1)}
          </span>

          {file.processedImage && (
            <span className="text-sm text-gray-600">
              {formatFileSize(file.processedImage.compressedSize)}(
              {file.processedImage.compressionRatio}% smaller)
            </span>
          )}
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-blue-600 h-2 rounded-full transition-all duration-300"
            style={{ width: `${file.progress || 0}%` }}
          />
        </div>

        {/* Error Message */}
        {file.error && <p className="text-red-600 text-sm">{file.error}</p>}

        {/* Actions */}
        <div className="flex gap-2 pt-2">
          {file.status === "ready" && (
            <button
              onClick={onUpload}
              className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
            >
              Upload
            </button>
          )}

          {file.status !== "uploading" && (
            <button
              onClick={onRemove}
              className="px-3 py-1 bg-gray-300 text-gray-700 rounded text-sm hover:bg-gray-400"
            >
              Remove
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilePreview;
